var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconChanges = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M10.5 7.5C10.086 7.5 9.75 7.836 9.75 8.25V11.253L1.5 11.25C1.086 11.25 0.75 11.5852 0.75 12C0.75 12.4148 1.08525 12.75 1.5 12.75L9.75 12.753V15.75C9.75 16.164 10.086 16.5 10.5 16.5C10.914 16.5 11.25 16.164 11.25 15.75V8.25C11.25 7.836 10.914 7.5 10.5 7.5Z", fill: "black" }),
            React.createElement("path", { d: "M14.25 11.25V8.25C14.25 7.836 13.914 7.5 13.5 7.5C13.086 7.5 12.75 7.836 12.75 8.25V15.75C12.75 16.164 13.086 16.5 13.5 16.5C13.914 16.5 14.25 16.164 14.25 15.75V12.75L22.5 12.753C22.914 12.753 23.25 12.4177 23.25 12.003C23.25 11.5882 22.9148 11.253 22.5 11.253L14.25 11.25Z", fill: "black" }))),
        alt: 'Changes',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconChanges;
//# sourceMappingURL=index.js.map